import { render, staticRenderFns } from "./RecommendedMissions.vue?vue&type=template&id=974412fe&scoped=true&"
import script from "./RecommendedMissions.vue?vue&type=script&lang=js&"
export * from "./RecommendedMissions.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedMissions.vue?vue&type=style&index=0&id=974412fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974412fe",
  null
  
)

export default component.exports